import { createFileRoute } from '@tanstack/react-router'

import { InsuranceCertificateGeneratorRealEstateAgentsPageSkeleton } from '#/modules/contract/front-office/insurance-certificate-generator-real-estate-agents-page/insurance-certificate-generator-real-estate-agents-page-skeleton.tsx'
import { InsuranceCertificateGeneratorRealEstateAgentsPage } from '#/modules/contract/front-office/insurance-certificate-generator-real-estate-agents-page/insurance-certificate-generator-real-estate-agents-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute(
  '/(customer)/_shell/insurance-certificate-generator-real-estate-agents-v2/$subscriptionId/',
)({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(
        context.trpc.contracts.getMyContract.queryOptions({
          subscriptionId: params.subscriptionId,
          includeTerminatedBeforeOneMonth: true,
        }),
      ),
      // The form needs today's date from the server: it bounds "date de délivrance" and marks today
      // in the calendar. Reading the clock client-side would break the "move time forward" feature.
      context.queryClient.ensureQueryData(context.trpc.timeManipulation.getCurrentCalendarDate.queryOptions()),
    ]),
  pendingComponent: InsuranceCertificateGeneratorRealEstateAgentsPageSkeleton,
  pendingMs: 150,
  component: InsuranceCertificateGeneratorRealEstateAgentsRoute,
})

function InsuranceCertificateGeneratorRealEstateAgentsRoute() {
  const { subscriptionId } = Route.useParams()
  return <InsuranceCertificateGeneratorRealEstateAgentsPage subscriptionId={subscriptionId} />
}
